import React, { useEffect } from "react";
import { Link } from "src/types/link";
import Links from "../links";
import { Collection } from "src/types/collections";
import { Asset } from "src/types/assets";
import { useDispatch } from "react-redux";
import { fetchAllLinks } from "src/redux/actions/link";
import { useSelector } from "react-redux";
import InfiniteScroll from "src/components/infiniteScroll";
import Loaders from "../loadingPlaceHolder";

import _ from "lodash";
interface ManageLinksProps {
  entity: Collection | Asset;
}

const ManageLinks: React.FC<ManageLinksProps> = ({ entity }) => {
  const links = useSelector((state: any) => _.get(state, "link.listOfLinks.items", []));
  const linkObject = useSelector((state: any) => state.link);
  const listOfLinks = _.get(linkObject, "listOfLinks", []);
  const pagination = _.get(linkObject, "pagination", {});
  const dispatch = useDispatch();

  const socialLinkGenerated = useSelector((state: any) => {
    const creating = _.get(state, 'link.generateLink.creating');
    if (creating) {
      return null;
    }

    return _.get(state, 'link.generateLink.link');
  });

  useEffect(() => {
    dispatch(
      fetchAllLinks({
        entityID: entity.id,
        entityType: entity.entityType,
        page: _.get(pagination, "currentPage", 0),
      }),
    );
  }, [socialLinkGenerated]);

  const [activeID, setActiveID] = React.useState("");
  const [deleteToggled, setDeleToggled] = React.useState(false);

  const loadMore = () => {
    const nextPage = _.get(pagination, "currentPage", 0) + 1;
    dispatch(
      fetchAllLinks({
        entityID: entity.id,
        entityType: entity.entityType,
        page: nextPage,
      }),
    );
  };

   if (links.length === 0 && !listOfLinks.loading) {
    return (
      <div>
        Links ? What links?
      </div>
    );
  }

  return (
    <InfiniteScroll
      hasMore={pagination.hasMore}
      loader={() => [1,2,3].map((i)=> <Loaders key={i}/> )}
      loadMore={() => loadMore()}
      loading={listOfLinks.loading}
    >
      {_.get(listOfLinks, "items", []).map((link: Link) => (
        <Links
          link={link}
          key={link.id}
          activeID={activeID}
          deleteToggled={deleteToggled}
          setDeleToggled={setDeleToggled}
          setActiveID={setActiveID}
          isLast={_.get(_.last(listOfLinks.items), "id") === link.id}
        />
      ))}
    </InfiniteScroll>
  );
};

export default ManageLinks;
